import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';

const PRESET_COLORS = [
  '#1565C0', // blu
  '#B71C1C', // rosso
  '#1B5E20', // verde
  '#F57F17', // giallo scuro
  '#4A148C', // viola
  '#BF360C', // arancio scuro
  '#263238', // grigio scuro
  '#FFFFFF', // bianco
];

interface Props {
  color: string;
  onChange: (color: string) => void;
}

export default function ShirtColorPicker({ color, onChange }: Props) {
  const [open, setOpen] = React.useState(false);

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <Tooltip title="Colore maglia">
        <IconButton size="small" onClick={() => setOpen((o) => !o)}>
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: '50%',
              bgcolor: color,
              border: '2px solid',
              borderColor: 'divider',
            }}
          />
        </IconButton>
      </Tooltip>

      {open && (
        <Box
          sx={{
            position: 'absolute',
            top: 36,
            right: 0,
            zIndex: 1300,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            p: 0.75,
            display: 'flex',
            flexWrap: 'wrap',
            gap: 0.5,
            width: 132,
            boxShadow: 3,
          }}
        >
          {PRESET_COLORS.map((c) => (
            <Box
              key={c}
              onClick={() => { onChange(c); setOpen(false); }}
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                bgcolor: c,
                cursor: 'pointer',
                border: c === color ? '2px solid' : '1px solid',
                borderColor: c === color ? 'primary.main' : 'divider',
                '&:hover': { transform: 'scale(1.15)' },
                transition: 'transform 0.1s',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
